import React from "react";
import "./About.css";
import Feature1 from "../../img/feature-1.png";
import Feature2 from "../../img/feature-2.png";
import Feature3 from "../../img/feature-3.png";
import Feature4 from "../../img/feature-4.png";
import AboutPhone from '../../img/phone-about.png'
import AboutCard from "../AboutCard/AboutCard";
const About = () => {
  return (
    <div className="about">
      <h2>What is Hishabee Business Manager?</h2>
      <p>
        Hishabee Business Manager is the most reliable and easy to use Business
        Solution on your mobile. Running a business hasn’t been easier.
        All-in-one Solution, made in Bangladesh, for Bangladesh.
      </p>
      <div className="about-details">
        <div className="left-detail">
            <AboutCard img={Feature1} txt1={`Sales Manager`} txt2={`Keep track of all your sales, income and invetory with Sales Manager.`}/>
            <AboutCard img={Feature2} txt1={`E-Commerce Store`} txt2={`Get your very own E-Commerce Store in 2 minutes. Powered by Hishabe.`}/>
        </div>
        <div className="middle-detail">
            <div className="about-screen">
                <img src={AboutPhone} alt="phone-cover" />
            </div>
        </div>
        <div className="right-detail">
        <AboutCard img={Feature3} txt1={`E-Commerce Store`} txt2={`Take Digital Payments easily and securely with a click of button.`}/>
        <AboutCard img={Feature4} txt1={`Marketing Manager`} txt2={`Start getting more customers with Hishabee Marketing Manager.`}/>

        </div>
      </div>

      <div className="btn-seemore">
          <button>See More</button>
      </div>
    </div>
  );
};

export default About;
